import { clsx } from "clsx";
import { twMerge } from "tailwind-merge"

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

// Membership dates (fecha_renovacion, fecha_activacion) are stored as UTC-midnight ISO
// strings representing a calendar day, not a real instant — formatting them with
// date-fns's format(new Date(iso), ...) converts to the browser's local timezone first,
// which can shift the displayed day by one (e.g. 2026-09-13T00:00:00Z shows as 12/09 for
// any timezone behind UTC). Reading the Y/M/D directly off the ISO string avoids that.
export function formatDateUTC(isoString) {
  if (!isoString) return 'N/A';
  const datePart = isoString.slice(0, 10);
  const [year, month, day] = datePart.split('-');
  if (!year || !month || !day) return 'N/A';
  return `${day}/${month}/${year}`;
}

// Same reasoning as formatDateUTC: compares calendar days only, so "renews tomorrow"
// doesn't flip to "renews today" or vice versa depending on the browser's timezone/time
// of day relative to the UTC-midnight stored value.
export function daysUntilUTCDate(isoString) {
  if (!isoString) return null;
  const datePart = isoString.slice(0, 10);
  const [year, month, day] = datePart.split('-').map(Number);
  const target = Date.UTC(year, month - 1, day);

  const now = new Date();
  const today = Date.UTC(now.getFullYear(), now.getMonth(), now.getDate());

  return Math.round((target - today) / 86400000);
}
